import React, {useMemo, useState, useEffect } from 'react';
import { Container, Row, Col, Card, Button, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
    FaMobileAlt
} from "react-icons/fa";
import { AiOutlineUserAdd } from "react-icons/ai";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { TfiPackage } from "react-icons/tfi";
import { FiLock } from "react-icons/fi";
import { HiOutlineRocketLaunch } from "react-icons/hi2";
import { RiSecurePaymentLine, RiStore2Line, RiShoppingCart2Line, RiGalleryView  } from "react-icons/ri";
import { FaStore, FaSms, FaKey, FaCog } from "react-icons/fa";
import PricingModule from "./PricingModule";
import { Branding, Helmetx } from '../services/misc';

import "./StartStore.scss";

const StartaButik = () => {
        const [modalPricingModuleShow,  setModalPricingModuleShow] = useState(false);
        const initPricingModuleModal = () => { return setModalPricingModuleShow(!modalPricingModuleShow) } 

    return (
        <>
            <Modal show={modalPricingModuleShow} onHide={initPricingModuleModal} size="xl">
                <Modal.Header closeButton>
                    {/* <Modal.Title>Butiksalternativ</Modal.Title> */}
                </Modal.Header>
                <Modal.Body>                
                <PricingModule> </PricingModule>
                </Modal.Body>
{/*                 <Modal.Footer>
                <Button variant="danger" onClick={initPricingModuleModal}>Close</Button>
                </Modal.Footer> */}
            </Modal>  

            <Helmetx/>
            <main className="starta-page">
                <div className="starta-wrapper">
                    <Container>
                        <h1 id="start-store-title" className="page-title text-center">
                            Så startar du din obemannade butik
                        </h1>
                        <p className="page-intro text-center">
                            Här ser du steg för steg hur du kommer igång med en obemannad butik – från val av abonnemang till färdig butik redo för kunder.
                        </p>

                        <Row className="g-4 mt-4" as="section" aria-labelledby="steps-title">

                            {/* Steg 1 */}
                            <Col md={4}>
                                <Card className="step-card">
                                    <AiOutlineUserAdd className="step-icon" aria-hidden="true" />
                                    

                                    <div className="card-content">
                                        <h3>1. Skapa konto</h3>
                                        <p>
                                            För att kunna använda våra tjänster så behöver du ett konto hos oss.
                                        </p>
                                    </div>

                                    <Button
                                        as={Link}
                                        to="/signup"
                                        className="step-button"
                                        title="Registrera konto"
                                    >
                                        Registrera konto
                                    </Button>
                                </Card>
                            </Col>

                            {/* Steg 2 */}
                            <Col md={4}>
                                <Card className="step-card">
                                    <RiShoppingCart2Line className="step-icon" aria-hidden="true" />

                                    <div className="card-content">
                                        <h3>2. Lägg till dina butiker</h3>
                                        <p>
                                            Innan du kan sälja något så behöver du skapa en eller flera butiker.
                                        </p>
                                    </div>

                                    <Button
                                        as={Link}
                                        //to="/PricingPage"
                                        onClick={initPricingModuleModal}
                                        
                                        className="step-button"
                                        title="Se abonnemang och priser för obemannad butik"
                                    >
                                        Visa butiksalternativ
                                    </Button>
                                    
                                </Card>
                            </Col>

                            {/* Steg 3 */}
                            <Col md={4}>
                                <Card className="step-card">
                                    <TfiPackage className="step-icon" aria-hidden="true" />


                                    <div className="card-content">
                                        <h3>3. Lägg till varor</h3>
                                        <p>
                                            Du behöver självklart varor i butiken. Logga in så hjälper vår guide dig.
                                        </p>
                                    </div>

                                    <Button
                                        as={Link}
                                        to="/login"
                                        className="step-button"
                                        title="Logga in"
                                    >
                                        Logga in
                                    </Button>
                                </Card>
                            </Col>                            

                            {/* Steg 4 */}
                            <Col md={4}>
                                <Card className="step-card">
                                    <RiSecurePaymentLine className="step-icon" aria-hidden="true" />

                                    <div className="card-content">
                                        <h3>4. Välj hur du vill ta betalt</h3>
                                        <p>
                                            Väljer du att låta oss hantera dina betalningar kostar det 2:-/transaktion.<br></br>
                                            Vill du använda ditt eget avtal för Swish handel kontakta oss så hjälper vi dig.
                                        </p>
                                    </div>
                                </Card>
                            </Col>

                            {/* Steg 5 */}
                            <Col md={4}>
                                <Card className="step-card">
                                    <FiLock className="step-icon" aria-hidden="true" />


                                    <div className="card-content">
                                        <h3>5. Installera lås eller kyl*</h3>
                                        <p>
                                            Installera ett digitalt lås eller ett digitalt låst kylskåp och anslut det till ditt lokala WiFi.
                                        </p>
                                    </div>
                                </Card>
                            </Col>
                            
                            {/* Steg 6 */}
                            <Col md={4}>
                                <Card className="step-card">
                                    <RiGalleryView  className="step-icon" aria-hidden="true" />


                                    <div className="card-content">
                                        <h3>6. Skapa en snygg skylt</h3>
                                        <p>
                                            Skapa din egna skylt eller använd någon av våra mallar.
                                        </p>
                                    </div>
                                </Card>
                            </Col>

                            {/* Steg 5 */}
                            <Col md={4}>
                                <Card className="step-card">
                                    <HiOutlineRocketLaunch className="step-icon" aria-hidden="true" />

                                    <div className="card-content">
                                        <h3>5. Öppna butiken</h3>
                                        <p>
                                            När allt är installerat och klart kan du aktivera butiken och börja ta emot dina kunder.
                                        </p>
                                    </div>
                                </Card>
                            </Col>

                            {/* SISTA ORANGE KORTET */}
                            <Col md={4}>
                                <Card className="step-card final-card">
                                    <IoMdCheckmarkCircleOutline className="step-icon" aria-hidden="true" />

                                    <div className="card-content">
                                        <h3>KLART!</h3>
                                        <p>
                                            Din obemannade butik är nu igång och redo att ta emot kunder dygnet runt.
                                        </p>
                                    </div>
                                </Card>
                            </Col>

                        </Row>
                    </Container>
                    <p className="starta-more text-center">
                        * När du i steg 5 valt vilken eller vilka butiker du ska ha så skicka vi dig låsmoduler eller kylskåp.
                        
                        {/* <Link to="/pris">abonnemang och priser</Link>. */}
                    </p>
                </div>
            </main>
        </>
    );
};

export default StartaButik;